module.exports = __webpack_public_path__ + "static/images/element-icons_535877f5.woff";


//////////////////
// WEBPACK FOOTER
// ./~/_element-ui@2.15.13@element-ui/lib/theme-chalk/fonts/element-icons.woff
// module id = 219
// module chunks = 1